import React from 'react'

const AboutWebshopSvg = () => (
  <svg width={303} height={294}>
    <defs>
      <linearGradient x1="50%" y1="0%" x2="50%" y2="50%" id="prefix__a">
        <stop stopColor="#FBFCFD" stopOpacity={0} offset="0%" />
        <stop stopColor="#F6F8F9" offset="100%" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <g
        fill="#FC4C02"
        fillRule="nonzero"
        className="about-webshop-drop-item about-webshop-drop-item-1"
      >
        <path d="M124.323 20.331c-1.255 0-2.428-.175-3.514-.52-1.087-.347-2.022-.867-2.809-1.558l2.201-2.623a6.55 6.55 0 002.114 1.108 7.59 7.59 0 002.202.335c.376 0 .645-.047.81-.14.166-.094.247-.224.247-.387v-.035c0-.178-.122-.327-.361-.442-.24-.117-.691-.24-1.348-.369a23.148 23.148 0 01-1.981-.494 6.81 6.81 0 01-1.656-.722 3.483 3.483 0 01-1.137-1.11c-.281-.447-.422-.993-.422-1.638V11.7c0-.588.114-1.135.344-1.639a3.73 3.73 0 011.003-1.32c.44-.377.988-.67 1.64-.882.649-.211 1.398-.317 2.245-.317 1.196 0 2.244.142 3.143.424.899.28 1.705.703 2.422 1.267l-2.007 2.783a6.187 6.187 0 00-1.859-.926 6.463 6.463 0 00-1.841-.291c-.304 0-.53.047-.677.14-.15.095-.22.219-.22.37v.036c0 .165.11.306.334.424.224.117.658.24 1.303.37.787.14 1.503.31 2.15.509.645.202 1.201.456 1.664.768.464.31.823.682 1.075 1.118.252.435.378.964.378 1.585v.036c0 .645-.128 1.228-.388 1.743a3.73 3.73 0 01-1.092 1.313c-.47.358-1.04.633-1.709.827-.668.195-1.421.292-2.254.292z" />
        <path d="M133.165 11.258h-3.628V7.773h11.38v3.485h-3.63v8.843h-4.122zM147.399 13.638c.493 0 .881-.106 1.162-.317.282-.212.423-.506.423-.882v-.036c0-.398-.141-.695-.423-.887-.28-.194-.664-.29-1.144-.29h-1.798v2.412h1.78zm-5.902-5.865h6.025c1.104 0 2.01.127 2.72.379.712.252 1.283.596 1.718 1.03.377.375.659.799.847 1.267.187.47.282 1.024.282 1.655v.037c0 .904-.217 1.667-.653 2.289-.434.622-1.026 1.117-1.78 1.479l2.871 4.192h-4.702l-2.326-3.523h-.88v3.523h-4.122V7.773z" />
        <path d="M177.364 14.797l2.687 5.304H184L177.364 7l-6.636 13.1h3.95l2.686-5.303zm-18.471 0l2.686 5.304h3.95L158.894 7l-6.633 13.1h3.949l2.684-5.303zm9.238-1.72l-2.688-5.304h-3.95l6.638 13.1 6.634-13.1h-3.948l-2.686 5.303z" />
      </g>
      <g
        fillRule="nonzero"
        className="about-webshop-drop-item about-webshop-drop-item-2"
      >
        <path
          d="M134.189 10.046a.885.885 0 00-.723-.447h-.56a.869.869 0 00-.715.451l-4.436 9.269c-.124.245.01.42.286.42h1.025c.405 0 .59-.184.7-.41.11-.225.354-.715.4-.815.064-.135.26-.218.534-.218l4.773.003c.275 0 .452.053.534.215.053.106.297.547.417.788.12.24.324.437.718.437h1.488c.275 0 .395-.208.296-.402l-4.737-9.29zm-2.803 6.819c-.275 0-.404-.205-.288-.454l1.748-3.745c.116-.25.304-.248.418.002l1.702 3.745c.113.25-.019.454-.293.454l-3.287-.002zm37.084-6.747v9.195c0 .253.224.426.5.426h1.212c.275 0 .5-.175.5-.45v-9.19c0-.275-.178-.5-.452-.5h-1.26c-.276 0-.5.17-.5.519zm-20.316 5.76c-.158-.226-.071-.475.192-.553 0 0 1.047-.314 1.549-.763.501-.451.753-1.102.753-1.95 0-.555-.097-1.022-.29-1.401a2.394 2.394 0 00-.83-.925 3.786 3.786 0 00-1.294-.523c-.503-.11-1.181-.141-1.181-.141a26.654 26.654 0 00-1-.023h-5.034a.5.5 0 00-.5.5v9.19c0 .275.225.45.5.45h1.192c.275 0 .5-.175.5-.45 0 0 0-3.655.003-3.655.002 0 .003-.002.003-.005s2.258-.006 2.258-.006c.275 0 .63.184.789.41l2.344 3.3c.218.293.425.406.7.406h1.557c.275 0 .319-.259.223-.394l-2.434-3.468zm-.948-1.867c-.309.07-.656.085-.656.085-.274.012-.724.022-.999.022h-2.334a.501.501 0 01-.5-.5v-1.862c0-.275.225-.5.5-.5h2.334c.275 0 .725.01.999.021 0 0 .347.014.656.085.308.072.553.17.732.3.18.128.308.28.386.454a1.4 1.4 0 01.116.57 1.4 1.4 0 01-.116.57 1.126 1.126 0 01-.386.455c-.179.129-.424.23-.732.3zm36.148-4.412c-.275 0-.497.181-.497.446l.003 5.879c0 .275-.155.338-.346.14l-5.886-6.105a1.15 1.15 0 00-.847-.36h-1.107c-.348 0-.5.186-.5.374v9.4c0 .188.178.366.453.366h1.109c.274 0 .467-.15.467-.402l.005-6.193c0-.275.156-.337.346-.139l6.137 6.38c.195.195.432.354.853.354h.833c.276 0 .5-.224.5-.5V10.1a.5.5 0 00-.5-.5h-1.023zm-23.997 5.732c-.133.24-.353.24-.485-.001l-2.877-5.284a.793.793 0 00-.722-.447h-1.56c-.276 0-.501.225-.501.5v9.178c0 .275.18.462.5.462h.97c.275 0 .474-.173.474-.438 0-.127.004-6.676.014-6.676.011 0 3.591 6.674 3.591 6.674.13.242.448.243.58.002 0 0 3.61-6.656 3.62-6.656.012 0 .008 6.465.008 6.656 0 .265.212.438.487.438h1.117c.276 0 .5-.137.5-.5V10.1a.5.5 0 00-.5-.5h-1.495a.813.813 0 00-.748.434l-2.973 5.298zM115 14.66c0 4.952 5.065 5.203 6.08 5.203 3.361 0 4.781-.908 4.84-.947a.886.886 0 00.467-.808V14.69a.572.572 0 00-.572-.572h-4.222c-.316 0-.523.257-.523.572v.354c0 .315.207.572.523.572h2.442c.236 0 .427.192.427.428l-.002 1.593c-.482.197-2.68.838-4.446.418-2.561-.613-2.76-2.726-2.76-3.36 0-.53.159-3.192 3.304-3.461 2.547-.218 4.223.81 4.24.82.3.155.609.044.776-.272 0-.003.318-.644.318-.644.132-.264.087-.538-.235-.756-.021-.012-1.806-.98-4.576-.98-5.91 0-6.081 4.72-6.081 5.258zM186.465 18.477h-.435v-.157h1.06v.157h-.438v1.273h-.187v-1.273zm2.095.645c-.01-.2-.024-.441-.024-.617h-.004c-.055.182-.115.363-.18.543l-.253.693h-.14l-.233-.68a6.85 6.85 0 01-.164-.556h-.004c-.006.21-.015.421-.027.632l-.039.613h-.176l.1-1.43h.236l.244.692c.06.176.106.333.144.481h.004c.038-.144.09-.301.153-.481l.255-.692h.236l.089 1.43h-.183l-.034-.628z"
          fill="#000"
        />
        <path
          d="M182.795 7.065h-6.633a.647.647 0 01-.573-.332.646.646 0 010-.661L178.906.33c.121-.21.33-.331.573-.331.243 0 .451.12.573.33l3.316 5.742a.645.645 0 010 .662.647.647 0 01-.573.331z"
          fill="#007CC2"
        />
      </g>
      <text
        fontFamily="Helvetica"
        fontSize={18}
        letterSpacing={0.245}
        fill="#227FCD"
        className="about-webshop-drop-item about-webshop-drop-item-3"
      >
        <tspan x={120.113} y={25}>
          {'3:22:16'}
        </tspan>
      </text>
      <path fill="url(#prefix__a)" d="M0 88h303v80H0z" />
      <rect
        stroke="#3C5364"
        strokeWidth={3}
        x={51.5}
        y={130.5}
        width={199.583}
        height={129}
        rx={13}
      />
      <path
        d="M107.417 292.5h87.75v-6.083a6.5 6.5 0 00-6.5-6.5h-74.75a6.5 6.5 0 00-6.5 6.5v6.083z"
        stroke="#3C5364"
        strokeWidth={3}
      />
      <path
        d="M53.667 230.292h195.366"
        stroke="#3C5364"
        strokeWidth={3}
        strokeLinecap="square"
      />
      <g stroke="#3C5364" strokeLinecap="square" strokeWidth={3}>
        <path d="M130.667 277.958v-16.5M171.917 277.958v-16.5" />
      </g>
      <path
        d="M68.736 159.25h166.43"
        stroke="#3C5364"
        strokeWidth={3}
        strokeLinecap="round"
      />
      <circle fill="#3C5364" cx={77.958} cy={152.375} r={2.292} />
      <circle fill="#3C5364" cx={70.625} cy={152.375} r={2.292} />
      <circle fill="#3C5364" cx={85.292} cy={152.375} r={2.292} />
      <path
        stroke="#227FCD"
        strokeWidth={3}
        strokeLinecap="round"
        d="M143.5 193.913l6.272 6.587 12.061-11"
        className="about-webshop-check"
      />
      <circle
        className="about-webshop-circle"
        stroke="#227FCD"
        strokeWidth={3}
        cx={152.667}
        cy={195}
        r={17.417}
      />
    </g>
  </svg>
)

export default AboutWebshopSvg
